export enum DeliveryPeriod {
  MORNING = 'morning',
  AFTERNOON = 'afternoon',
}

export enum DeliveryType {
  HOME_PICKUP = 'HomePickup',
  DROP_POINT = 'DropPoint',
  ARBITRATION = 'Arbitration',
  NEGATIVE_REFUND = 'SrmActionRequiredNegativeRefund',
  BULKY_INVOLUNTARI = 'BulkyInvoluntary',
  BULKY_BY_MYSELF = 'BulkyByMyself',
  BY_MYSELF = 'ByMyself',
  HIGH_VALUE_INVOLUNTARY = 'HighValueInvoluntary',
}

export const SPECIAL_DELIVERY_TYPES: string[] = [
  DeliveryType.ARBITRATION,
  DeliveryType.BULKY_INVOLUNTARI,
  DeliveryType.HIGH_VALUE_INVOLUNTARY,
]

export enum CountryCode {
  SPAIN = 'ES',
  ITALY = 'IT',
}
export enum CultureCode {
  ES_MX = 'es-MX',
  IT_CH = 'it-CH',
}

export enum ReturnReason {
  VOLUNTARY = 'VOLUNTARY',
  INVOLUNTARY = 'INVOLUNTARY',
}

export enum ReturnFlowSteps {
  SHOW_PRODUCT_LIST = 'ShowProductList',
  RETURN_MENU = 'ReturnMenu',
  NOT_ELIGIBLE = 'NotEligible',
  MODIFY_RETURN_SRM = 'ModifyReturnSRM',
  NOT_MODIFIABLE = 'NotModifiable',
  SPECIAL_CARRIER = 'SpecialCarrier',
}

// returns pages
export const RETURN = 'RETURN'
export const MODIFY = 'MODIFY'

// TODO (juan.rueda): refactor to unify Contact Form FlowSteps and Contact Form Pages
// contact form Flow Steps
export const CONTACT_FORM_FLOW_STEPS = [
  ReturnFlowSteps.NOT_MODIFIABLE,
  ReturnFlowSteps.MODIFY_RETURN_SRM,
  ReturnFlowSteps.NOT_ELIGIBLE,
  ReturnFlowSteps.SPECIAL_CARRIER,
]
// contact form Pages
export const CONTACT_FORM_PAGES = [
  ReturnFlowSteps.NOT_MODIFIABLE,
  ReturnFlowSteps.MODIFY_RETURN_SRM,
  ReturnFlowSteps.NOT_ELIGIBLE,
  ReturnFlowSteps.SPECIAL_CARRIER,
  MODIFY,
  DeliveryType.NEGATIVE_REFUND,
]

export enum SiteId {
  VEEPEE_FR = 1, // France FR and Switzerland
  VEEPEE_DE = 2, // Deutschland DE
  VEEPEE_ES = 3, // Spain ES
  VEEPEE_IT = 4, // Italy IT
  VEEPEE_AT = 7, // Austria AT
  PRIVALIA_ES = 66, // Privalia Spain ES
  PRIVALIA_IT = 69, // Privalia Italy IT
  VEEPEE_FR_BE = 70, // Benelux Belgium BE-FR
  VEEPEE_NL_BE = 71, // Benelux Belgium BE-NL
  VEEPEE_FR_LU = 73, // Benelux Luxembourg LU-FR
  VEEPEE_NL_NL = 76, // Benelux Netherlands NL-NL
}

export enum Lang {
  FR = 'fr',
  DE = 'de',
  ES = 'es',
  IT = 'it',
  EN = 'en',
  NL = 'nl',
}

export const SiteIdToLangMap: { [key in SiteId]: Lang } = {
  [SiteId.VEEPEE_FR]: Lang.FR,
  [SiteId.VEEPEE_DE]: Lang.DE,
  [SiteId.VEEPEE_ES]: Lang.ES,
  [SiteId.VEEPEE_IT]: Lang.IT,
  [SiteId.VEEPEE_AT]: Lang.DE,
  [SiteId.PRIVALIA_ES]: Lang.ES,
  [SiteId.PRIVALIA_IT]: Lang.IT,
  [SiteId.VEEPEE_FR_BE]: Lang.FR,
  [SiteId.VEEPEE_NL_BE]: Lang.NL,
  [SiteId.VEEPEE_FR_LU]: Lang.FR,
  [SiteId.VEEPEE_NL_NL]: Lang.NL,
}

export const PRIVALIA_SITE_ID = [SiteId.PRIVALIA_ES, SiteId.PRIVALIA_IT]
export const VEEPEE_PURPLE_SITE_ID = [SiteId.VEEPEE_DE, SiteId.VEEPEE_AT]
export const VEX_SITE_IDS = [SiteId.VEEPEE_FR_BE, SiteId.VEEPEE_NL_BE, SiteId.VEEPEE_FR_LU, SiteId.VEEPEE_NL_NL]

export enum TypeTranslationKey {
  HOME_PICKUP_KEY = 'home_pickup',
  POST_OFFICE_KEY = 'post_office',
  ON_ITS_OWN_KEY = 'on_its_own',
  RETURN_BULKY_BY_MYSELF = 'return_by_myself',
  RETURN_BY_MYSELF = 'return_by_myself_2',
}

// note(@dbonnay) should be imported from addresscore when available
export const ADDRESS_LIST = 'LIST'
export const ADDRESS_ADD = 'ADD'

// AddressList addressType
export const PICKUP_POINT = 'PICKUP_POINT'
export const MY_ADDRESSES = 'MY_ADDRESSES'

// help contact form subject ids
export const RETURN_PPO_SUBJECT_ID = 3000
export const RETURN_SUBJECT_ID = 3031
export const RETURN_SPECIAL_CARRIER_SUBJECT_ID = 3041
export const RETURN_NEGATIVE_REFUND_SUBJECT_ID = 3042
export const RETURN_EXPIRED_SUBJECT_ID = 3043
export const RETURN_NOT_MODIFIABLE_SUBJECT_ID = 3044
export const RETURN_DROP_POINT_SUBJECT_ID = 3045

// date format options
export const DATE_OPTIONS_2DIGITS = {
  year: '2-digit',
  month: '2-digit',
  day: '2-digit',
} as const
export const DATE_OPTIONS_WEEKDAY_LONGDATE = {
  weekday: 'long',
  year: 'numeric',
  month: 'long',
  day: 'numeric',
} as const

export const UNAUTH_ERROR = {
  status: 401,
  error: { error_code: 'Unauthorized' },
}

export enum FormType {
  HELP_FORM = 'helpForm',
  CONTACT_REASON_FORM = 'contactReasonForm',
}

export const NO_VALUE_SELECTED = 'no value selected'

export enum Device {
  DESKTOP = 'desktop',
  TABLET = 'tablet',
  MOBILE = 'mobile',
}

export enum Size {
  SMALL = 'small',
  MEDIUM = 'medium',
}

export enum PayMethod {
  VISA = 'visa',
  MAESTRO = 'maestro',
  MASTERCARD = 'mastercard',
  AMEX = 'amex',
  CB = 'cb',
}

export enum SideMenuActiveLink {
  TITLE = 'title',
  ADDRESSES = 'addresses',
  WALLET = 'wallet',
  VOUCHERS = 'vouchers',
}

export enum CancellableStatus {
  CANCELLABLE = 'cancellable',
  IN_PROGRESS = 'inProgress',
  NOT_CANCELLABLE = 'notCancellable',
  ALREADY_CANCELLED = 'alreadyCancelled',
}

export enum ContactMethods {
  WHATSAPP = 'WhatsApp',
  PHONE = 'Phone',
  MESSENGER = 'Messenger',
}

export const RECYCLE_CONTACT_REASON_TYPES = {
  FORM: 'FORM',
  TEXT: 'TEXT',
  MIXED: 'MIXED',
}
export const RECYCLE_CONTACT_REASONS = [
  {
    value: 5000,
    subjectId: 5000,
    label: "Informations sur l'offre / les articles",
    type: 'FORM',
    extraText: '',
  },
  {
    value: 5001,
    subjectId: 5001,
    label: "Processus d'achat",
    type: 'FORM',
    extraText: '',
  },
  {
    value: 5002,
    subjectId: 5002,
    label: 'Question sur ma commande',
    type: 'FORM',
    extraText: '',
  },
  {
    value: 5003,
    subjectId: 5003,
    label: "Question sur l'expédition de ma commande",
    type: 'MIXED',
    extraText:
      "Dès lors que votre commande Re-cycle Seconde main aura été expédiée, vous recevrez un e-mail pour vous en notifier, contenant un lien de suivi de votre colis. Si vous rencontrez une quelconque difficulté à ce sujet, n'hésitez pas à nous contacter via ce formulaire.",
  },
  {
    value: null,
    subjectId: null, // note(juan.rueda): TEXT type has no subjectId
    label: 'Demande suite à la réception de mon colis',
    type: 'TEXT',
    extraText:
      'Si vous souhaitez nous retourner un ou plusieurs articles, rendez-vous sur votre compte Re-cycle Seconde main, rubrique “Mes commandes” pour effectuer une demande. Une fois les documents de retour en votre possession, vous disposerez de 14 jours calendaires pour nous renvoyer votre colis.',
  },
  {
    value: 5004,
    subjectId: 5004,
    label: 'Suivi de mon colis retour',
    type: 'MIXED',
    extraText:
      "Une fois le renvoi de votre colis effectué, celui-ci sera acheminé à notre entrepôt. A la réception de votre retour, un e-mail vous sera envoyé (comptez en moyenne 8 jours pour l'acheminement vers nos entrepôts). Notre équipe logistique contrôlera ensuite la conformité de votre/ vos colis retour et engagera le/leur remboursement. Si vous rencontrez une quelconque difficulté à ce sujet, n'hésitez pas à nous contacter via ce formulaire.",
  },
  {
    value: 5005,
    subjectId: 5005,
    label: 'Question sur le remboursement de ma commande',
    type: 'FORM',
    extraText: '',
  },
  {
    value: 5006,
    subjectId: 5006,
    label: 'Problème technique',
    type: 'FORM',
    extraText: '',
  },
]
export const NOTIFICATION_CONTAINER = 'postsalesNotificationContainer'

export enum VOUCHER_FORMAT {
  FIXED = 'FIXED',
  PERCENT = 'PERCENT',
}
export enum VOUCHER_APPLICABILITY {
  PRODUCT = 'PRODUCT',
  SHIPPING = 'SHIPPING',
}
export enum TICKET_TYPE {
  VOUCHER = 'voucher',
  PROMOTION = 'promotion',
}

export enum IbanFormField {
  IBAN = 'iban',
  BIC = 'bic',
  OWNERNAME = 'ownerName',
  IS_CHECKED = 'isChecked',
}

export enum ContactButtonType {
  FAQ = 'faq',
  CONTACT_US = 'contactUs',
  CHAT = 'chat',
}

export const PICKUP_POINTS = {
  WIDGET_COPIES: {
    selectTitle: 'returns.drop_point.select.title',
    notAvailableTitle: 'errors.returns.drop_point.not_available.modal.title',
    notAvailableText: 'errors.returns.drop_point.not_available.modal.text',
    schedule: 'returns.drop_point.schedule',
  },
  API_URL: '/api/pickuppoints/v1/pickup-points/search-for-returns',
}

export enum SideMenuKeyEnum {
  ADDRESS_BOOK = 'address-book',
  FAVOURITES = 'favourites',
  LIFE2_FAVORITES = 'life2-favourites',
  MEMBER_GET_MEMBER = 'member-get-member',
  MES_EVALUATIONS = 'mes-evaluations',
  MESSAGES = 'messaged',
  MON_DRESSING = 'mon-dressing',
  MON_PARTE_MONNAINE = 'mon-parte-monnaine',
  MY_ACCOUNT = 'my-account',
  MY_ORDERS = 'my-orders',
  NOTIFICATIONS_ALERTS = 'notifications-alerts',
  PAYMENT_METHODS = 'payment-methods',
  PERSONAL_DATA = 'personal-data',
  PREMIUM = 'premium',
  TRANSACTIONS = 'transactions',
  VOUCHERS_PROMOS = 'vouchers-promos',
  MESSAGE_CENTER = 'message-center',
  ROSE_DEALS = 'rose-deal',
  HELP = 'help',
  HANDS = 'general-conditions',
  MY_SUBSCRIPTIONS = 'subscriptions',
  BRANDS = 'brands',
  MENU = 'menu',
}

export const grootPageBasePath = '/gr'

export const WalletScreen = {
  PAY_METHODS: 'payMethods',
  WALLET_DETAILS: 'walletDetails',
  CASHOUT_COMPLETED: 'cashoutCompleted',
}

export const LinkType = {
  DEFAULT: 'Default',
  BLANK: 'Blank',
  MODAL: 'Modal',
  DEEP_LINK: 'DeepLink',
}

export const BrandAlertsSubs = {
  channel: {
    NONE: 'None',
    EMAIL: 'Email',
    PUSH: 'Push',
    EMAIL_AND_PUSH: 'EmailPush',
  },
  schedule: {
    None: 'None',
    PREVIOUS_DAY: 'D0',
    OPENING_DAY: 'D1',
    PREVIOUS_AND_OPENING_DAY: 'D0D1',
  },
}

export const DEFAULT_FAV_CONF_COPIES = {
  'favorites.notifications_settings.modal.title': 'favorites.notifications_settings.modal.title',
  'favorites.alerts.notification.tooltip': 'favorites.alerts.notification.tooltip',
  'favorites.notifications_settings.modal.text': 'favorites.notifications_settings.modal.text',
  'favorites.notifications_settings.modal.settings.cta': 'favorites.notifications_settings.modal.settings.cta',
  'favorites.alerts.notification': 'favorites.alerts.notification',
  'favorites.alerts.cta.cancel': 'favorites.alerts.cta.cancel',
  'favorites.alerts.email': 'favorites.alerts.email',
  'favorites.alerts.cta.confirm': 'favorites.alerts.cta.confirm',
  'favorites.alerts.both': 'favorites.alerts.both',
  'favorites.alerts.previous_day': 'favorites.alerts.previous_day',
  'favorites.alerts.notification.changes_saved': 'favorites.alerts.notification.changes_saved',
  'favorites.alerts.opening_day': 'favorites.alerts.opening_day',
  'favorites.alerts.title': 'favorites.alerts.title',
  'errors.general_retry.notification': 'errors.general_retry.notification',
}

export enum OrderStatus {
  ACTIVE = 'active',
  CANCELLED = 'cancelled',
  EXPIRED = 'expired',
  IN_PREPARATION = 'in_preparation',
  RECEIVED = 'received',
  RECEIVED_PARTIALLY = 'received_partially',
  REFUNDED = 'refunded',
  REFUND_IN_PROGRESS = 'refund_in_progress',
  RETURNED = 'returned',
  RETURN_REQUESTED = 'return_requested',
  RETURN_REQUESTED_DENIED = 'return_requested_denied',
  RETURN_REQUESTED_ACCEPTED = 'return_requested_accepted',
  RETURN_RECEIVED = 'return_received',
  SHIPPED = 'shipped',
  SHIPPED_PARTIALLY = 'shipped_partially',
  VALIDATED = 'validated',
  VALIDATED_AVAILABLE = 'validated_available',
}

export enum OrderDetailsType {
  FLASH_SALE = 'FlashSale',
  VEEPEE = 'Veepee',
  SECOND_HAND = 'SecondHand',
  M2M = 'M2M',
  VBI = 'Vbi',
  PREMIUM = 'Premium',
  MARKETPLACE = 'Marketplace',
}

export enum AddressSectionType {
  DELIVERY = 'DeliveryAddress',
  INVOICE = 'InvoiceAddress',
  RETURN = 'ReturnAddress',
}

export enum LabelColor {
  BLUE = 'blue',
  GREEN = 'green',
  GREY = 'grey',
  ORANGE = 'orange',
  RED = 'red',
}

export const MAX_PARCELS_DISPLAYED = 3

export enum SellerColorType {
  INTERNAL = 'Internal',
  EXTERNAL = 'External',
}

export const DEFAULT_SELLER_NAME = 'Veepee'

export enum OrderDetailsDeliveryType {
  HOME_PICKUP = 'Home',
  PICKUP_POINT = 'PuP',
}

export enum CarrierIdValue {
  COL = 'COL',
  MRL = 'MRL',
  RCL = 'RCL',
  COR = 'COR',
  PIT = 'PIT',
  ASM = 'ASM',
  GLS = 'GLS',
  MRW = 'MRW',
  BPOST = 'BPOST',
  INPOST = 'INPOST',
  AT_DHL_CONNECT = '(AT)_DHL_CONNECT',
  NL_DHL_CONNECT = '(NL)_DHL_CONNECT',
  DHL_AT = 'DHL_AT',
  DHL_DE = 'DHL_DE',
  POST_NL = 'POST_NL',
  CHRPST = 'CHRPST',
  UPS = 'UPS',
  TNT = 'TNT',
  ES_PAACK = '(ES)_PAACK',
}
